<circle-progress
  [percent]="percentage"
  [radius]="70"
  [outerStrokeWidth]="5"
  [innerStrokeWidth]="5"
  [outerStrokeColor]="'#008000'"
  [innerStrokeColor]="'#DAA520'"
  [animation]="true"
  [animationDuration]="300"
  [titleFontSize]="'25'"
  [unitsFontSize]="'25'"
  [subtitleFontSize]="'15'"

  [attr.role]="'progressbar'"
  [attr.aria-label]="'trProgressValue' | translate"
  [attr.aria-valuenow]="percentage"
  [attr.aria-valuemin]="0"
  [attr.aria-valuemax]="100"
></circle-progress>
